import * as React from 'react';

import { FiltersContainer, FiltersDesktopContainer } from '../../containers/Filters';
import { NotificationContainer } from '../../containers/Notifications';
import { ResultsContainer } from '../../containers/Results';
import { FoldersNotificationContainer } from '../../containers/FoldersNotificationContainer';

export function Page() {
  return (
    <>
      <FiltersContainer />
      <ResultsContainer />
      <NotificationContainer />
      <FiltersDesktopContainer />
      <FoldersNotificationContainer />
    </>
  );
}
